<template>
  <div class="shopInfoCom">
    <div class="tabs">
      <van-tabs @click="TabsIndex" v-model="active" color="rgb(25,137,250)">
        <van-tab title="基本信息">
          <van-field
            label="店招名称"
            v-model="shopBasicData.shopName"
            placeholder="请输入"
            input-align="right"
            :readonly="!isEdit"
          />
          <van-field
            label="门店负责人"
            v-model="shopBasicData.shopPrincipal"
            placeholder="请输入"
            input-align="right"
            :readonly="!isEdit"
          />
          <van-field
            label="门店电话"
            v-model="shopBasicData.shopPhone"
            placeholder="请输入"
            input-align="right"
            :readonly="!isEdit"
          />
          <template v-if="isEdit">
            <van-field
              readonly
              label="负责人类型"
              :value="
                shopBasicData.shopPrincipalType === 2 ? '店长' : shopBasicData.shopPrincipalType === 1 ? '老板' : '其他'
              "
              placeholder="请输入"
              input-align="right"
              @click="shopBossPickerFlag = true"
            />
            <van-popup v-model="shopBossPickerFlag" position="bottom">
              <van-picker
                show-toolbar
                :columns="['老板', '店长', '其他']"
                @cancel="shopBossPickerFlag = false"
                @confirm="onShopBossConfirm"
              />
            </van-popup>
            <van-field
              label="负责人电话"
              v-model="shopBasicData.shopPrincipalPhone"
              placeholder="请输入"
              input-align="right"
            />
            <van-field
              readonly
              label="所在区域"
              v-model="shopBasicData.city"
              placeholder="请输入"
              input-align="right"
              @click="showCityTypePicker = true"
            />
            <van-popup v-model="showCityTypePicker" round position="bottom">
              <city-picker
                :title="'选择所在区域'"
                :confirm="cityConfirm"
                :cancel="
                  () => {
                    showCityTypePicker = false
                  }
                "
                ref="cPicker"
              ></city-picker>
            </van-popup>
            <van-field label="门店地址" v-model="shopBasicData.shopAddress" placeholder="请输入" input-align="right" />
          </template>
          <!-- 地图 -->
          <div class="shop-map">
            <div id="shop-map" style="width: 100%; height:100%;" v-show="!isEdit"></div>
            <div class="addressInfo" v-show="!isEdit">
              <div class="leftDesc">
                <p class="title" id="shop-title"></p>
                <p class="subtitle" id="shop-subtitle"></p>
              </div>
            </div>
          </div>
        </van-tab>

        <div class="shop-item-cont">
          <van-tab title="店铺信息">
            <van-field
              readonly
              label="门店类型"
              :value="shopMerchantData.shopType"
              placeholder="请输入"
              input-align="right"
              v-if="!isEdit"
            />
            <van-field
              readonly
              label="门店类型"
              :value="shopMerchantData.shopType"
              placeholder="请输入"
              input-align="right"
              right-icon="arrow"
              v-else
              @click="shopTypePickerFlag = true"
            />
            <van-popup v-model="shopTypePickerFlag" position="bottom">
              <van-picker
                show-toolbar
                :columns="['加盟连锁店', '品牌自营连锁店', '私营门店']"
                @cancel="shopTypePickerFlag = false"
                @confirm="onShopTypeConfirm"
              />
            </van-popup>
            <van-field
              readonly
              label="主营服务"
              :value="shopMerchantData.mainService"
              placeholder="请输入"
              input-align="right"
              v-if="!isEdit"
            />
            <van-field
              readonly
              label="主营服务"
              :value="shopMerchantData.mainService"
              placeholder="请输入"
              input-align="right"
              right-icon="arrow"
              v-else
              @click="showMainPickerFlag = true"
            />
            <van-popup v-model="showMainPickerFlag" position="bottom">
              <van-picker
                show-toolbar
                :columns="['洗车', '美容装潢', '维修保养', '综合服务', '轮胎']"
                @cancel="showMainPickerFlag = false"
                @confirm="onShowMainConfirm"
              />
            </van-popup>
            <van-field
              label="营业项目"
              :value="shopMerchantData.businessItems"
              placeholder="请输入"
              input-align="right"
              :readonly="!isEdit"
              v-if="!isEdit"
            />
            <van-collapse v-model="activeNames" v-else style="text-align:left">
              <van-collapse-item title="营业项目" name="2">
                <van-checkbox-group v-model="businessItemsSelected" direction="horizontal">
                  <van-checkbox
                    :name="item"
                    v-for="item in allServices"
                    :key="item"
                    style="margin-bottom:5px;margin-right: 5px;width: 30%"
                    >{{ item }}</van-checkbox
                  >
                </van-checkbox-group>
              </van-collapse-item>
            </van-collapse>
            <van-field
              readonly
              label="营业面积"
              :value="shopMerchantData.merchantArea"
              placeholder="请输入"
              input-align="right"
              v-if="!isEdit"
            />
            <van-field
              readonly
              label="营业面积"
              :value="shopMerchantData.merchantArea"
              placeholder="请输入"
              input-align="right"
              right-icon="arrow"
              v-else
              @click="showAreaPickerFlag = true"
            />
            <van-popup v-model="showAreaPickerFlag" position="bottom">
              <van-picker
                show-toolbar
                :columns="[
                  '100平米以下',
                  '100-200平米',
                  '200-300平米',
                  '300-400平米',
                  '400-500平米',
                  '500-600平米',
                  '600-700平米'
                ]"
                @cancel="showAreaPickerFlag = false"
                @confirm="onShowAreaConfirm"
              />
            </van-popup>
            <van-field
              label="洗车工位"
              maxlength="2"
              :value="washCount1 === undefined ? shopMerchantData.washCount : washCount1"
              @input="washCountInput"
              placeholder="请输入"
              input-align="right"
              :readonly="!isEdit"
            />
            <van-field
              label="美容工位"
              maxlength="2"
              :value="beautyCount1 === undefined ? shopMerchantData.beautyCount : beautyCount1"
              @input="beautyCountInput"
              placeholder="请输入"
              input-align="right"
              :readonly="!isEdit"
            />
            <van-field
              label="维保工位"
              maxlength="2"
              :value="repairCount1 === undefined ? shopMerchantData.repairCount : repairCount1"
              @input="repairCountInput"
              placeholder="请输入"
              input-align="right"
              :readonly="!isEdit"
            />
            <van-field
              label="烤漆房数"
              maxlength="2"
              :value="copyCount1 === undefined ? shopMerchantData.copyCount : copyCount1"
              @input="copyCountInput"
              copyCount1
              placeholder="请输入"
              input-align="right"
              :readonly="!isEdit"
            />
            <van-field
              label="独立休息区"
              :value="shopMerchantData.haveRestArea === 0 ? '无' : '有'"
              placeholder="请输入"
              input-align="right"
              :readonly="!isEdit"
              v-if="!isEdit"
            />
            <van-cell title="独立休息区" v-else style="text-align: left">
              <template slot="default">
                <van-radio-group v-model="restArea" direction="horizontal">
                  <van-radio :name="1">有</van-radio>
                  <van-radio :name="0">无</van-radio>
                </van-radio-group>
              </template>
            </van-cell>
          </van-tab>
        </div>

        <van-tab title="企业信息">
          <van-field
            label="营业执照"
            v-model="shopCompanyData.businessLicense === 0 ? '无' : '有'"
            placeholder="请输入"
            input-align="right"
            :readonly="!isEdit"
            v-if="!isEdit"
          />

          <van-cell title="营业执照" v-else style="text-align: left">
            <template slot="default">
              <van-radio-group v-model="businessLicense" direction="horizontal">
                <van-radio :name="1">有</van-radio>
                <van-radio :name="0">无</van-radio>
              </van-radio-group>
            </template>
          </van-cell>

          <van-field
            v-if="businessLicense == 1"
            label="企业主体"
            maxlength="18"
            v-model="shopCompanyData.businessEntity"
            placeholder="请输入"
            input-align="right"
            :readonly="!isEdit"
          />
          <van-field
            v-if="businessLicense == 1"
            label="企业信用代码"
            maxlength="18"
            v-model="shopCompanyData.shopCreditCode"
            placeholder="请输入"
            input-align="right"
            :readonly="!isEdit"
          />
          <van-field
            label="企业法人"
            maxlength="6"
            v-model="shopCompanyData.enterprisePrincipal"
            placeholder="请输入"
            input-align="right"
            :readonly="!isEdit"
          />
          <van-field
            label="法人手机"
            type="number"
            maxlength="11"
            v-model="shopCompanyData.enterprisePrincipalPhone"
            placeholder="请输入"
            input-align="right"
            :readonly="!isEdit"
          />
          <van-field
            label="员工人数"
            maxlength="10"
            v-model="shopCompanyData.staffNum"
            placeholder="请输入"
            input-align="right"
            :readonly="!isEdit"
          />
        </van-tab>

        <van-tab class="shop_img" title="证照店照">
          <template v-if="isEdit">
            <div
              class="certificate_photo"
              v-upload="{ onUpload: upload2, index: index, refresh: true }"
              v-for="(item, index) in CertificatePhotoData"
              :key="index"
            >
              <div class="img-cont">
                <img :src="item.imgUrl" v-if="item.imgUrl" />
                <img :src="addIcon" class="add-icon" v-else />
              </div>
              <span>{{ item.name }}</span>
            </div>
          </template>
          <div
            class="certificate_photo"
            v-else
            v-for="(item, index) in CertificatePhotoData"
            v-show="item.imgUrl !== null"
            :key="index"
          >
            <div class="img-cont">
              <img :src="item.imgUrl" />
            </div>
            <span>{{ item.name }}</span>
          </div>
        </van-tab>
      </van-tabs>
      <van-button
        v-if="isEdit"
        @click="handleSave"
        class="shop_info_btn"
        size="large"
        color="rgb(25,137,250)"
        plain
        type="info"
        :hairline="true"
        >保存</van-button
      >
    </div>
  </div>
</template>
<script>
import cityPicker from '@/components/cityPicker.vue'
import addIcon from '@/imgs/image/add.png'
import config from '@/configs/config'
import { localStorage } from '@/commons/storage'
import { ContactCard } from 'vant'
const showParams = {
  shopBossPickerFlag: false, // 门店负责人
  showCityTypePicker: false,
  shopTypePickerFlag: false, // 门店类型
  showMainPickerFlag: false, // 门店主营类型
  showAreaPickerFlag: false // 营业面积
}

export default {
  components: { cityPicker },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    _shopBasicData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    _shopMerchantData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    _shopCompanyData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    _CertificatePhotoData: {
      type: Array,
      default: () => {
        return []
      }
    },
    _showTab: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  data() {
    return {
      active: 0,
      ...showParams,
      shopBasicData: {},
      shopMerchantData: {},
      shopCompanyData: {},
      CertificatePhotoData: {},
      defaultCityValue: ['', '', ''],
      activeNames: ['1'],
      allServices: [
        '洗车',
        '装潢',
        '保养',
        '救援',
        '年检',
        '保险',
        '油漆',
        '轮胎',
        '安全检测',
        '四轮定位',
        '动平衡',
        '理赔'
      ],
      businessItemsSelected: [], // 营业项目
      restArea: 1, // 有休息区
      businessLicense: 1, // 有营业执照
      washCount1: 0, // 洗车工位
      beautyCount1: 0, // 美容工位
      repairCount1: 0, // 维护工位
      copyCount1: 0, // 烤漆工位
      addIcon,
      title: '',
      tabList1: [
        {
          name: '员工权限',
          url: '/pages/changeShopInfo/index'
        }
      ],
      startImgNum: '',
      endImgNum: '',
      tabIndex: 0,
      businessLicenseFlag: true,
      map: null
    }
  },
  watch: {
    _shopBasicData(val) {
      val.city = `${val.provinceName}-${val.cityName}-${val.districtName}`
      this.shopBasicData = val
    },
    _shopMerchantData(val) {
      this.businessItemsSelected = val.businessItems.split(',') // 已选项目
      // console.log('this.businessItemsSelected', val.businessItems.split(',').splice(1), this.businessItemsSelected)
      this.restArea = val.haveRestArea || 0
      // 初始赋值 undefined
      this.washCount1 = val.washCount
      this.beautyCount1 = val.beautyCount
      this.repairCount1 = val.repairCount
      this.copyCount1 = val.copyCount
      const arr = val.stationCondition.split(';')
      let obj = {}
      arr.forEach(item => {
        if (item.indexOf('洗车') > -1) {
          obj['washCount'] = item.split('_')[1] || 0
        } else if (item.indexOf('美容') > -1) {
          obj['beautyCount'] = item.split('_')[1] || 0
        } else if (item.indexOf('维护') > -1) {
          obj['repairCount'] = item.split('_')[1] || 0
        } else if (item.indexOf('烤漆') > -1) {
          obj['copyCount'] = item.split('_')[1] || 0
        } else {
        }
      })
      this.shopMerchantData = Object.assign(val, obj)
      // console.log(this.shopMerchantData, '格式化后的店铺信息')
    },
    _shopCompanyData(val) {
      this.businessLicense = val.businessLicense || 0
      this.shopCompanyData = val
      // val.businessLicense === 0 ? this.businessLicenseFlag = false : this.businessLicenseFlag = true
    },
    _CertificatePhotoData(val) {
      this.CertificatePhotoData = val
      this.startImgNum = this.CertificatePhotoData.length
      this.endImgNum = this.CertificatePhotoData.length
      // console.log('CertificatePhotoData', this.CertificatePhotoData[4].imgUrl === null)
      // console.log(this.CertificatePhotoData, '格式化后的店铺信息')
    },
    _showTab(val) {
      this.tabIndex = val
      this.active = val
    }
  },
  created() {
    this.active = this.tabIndex
    this.ShowTab()
  },
  computed: {
    shopId() {
      const shopInfo = tuhu.store.state.currentShopInfo
      return shopInfo ? shopInfo.shopId : tuhu.getParam('shopId')
    }
  },
  methods: {
    cityConfirm(val, i) {
      let res = this.$refs.cPicker.cityData(i)
      console.log(res, '2222222222222222')
      this.$set(this.shopBasicData, 'city', val.join().replace(/,/g, '-'))
      this.$set(this.shopBasicData, 'cityId', res.cityId)
      this.$set(this.shopBasicData, 'cityName', val[1])
      this.$set(this.shopBasicData, 'provinceId', res.provinceId)
      this.$set(this.shopBasicData, 'provinceName', val[0])
      this.$set(this.shopBasicData, 'districtId', res.districtId)
      this.$set(this.shopBasicData, 'districtName', val[2])
      this.showCityTypePicker = false
    },
    initMap(data) {
      this.map = null
      this.shopMapData = data
      this.$nextTick(() => {
        document.getElementById('shop-title').innerText = data.name
        document.getElementById('shop-subtitle').innerText = data.address
        this.map = new AMap.Map('shop-map', {
          zoom: 11,
          viewMode: '2D',
          center: [data.lng, data.lat],
          resizeEnable: true
        })
        // var icon = new AMap.Icon({
        //   image: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        //   size: new AMap.Size(25, 34), // 图标尺寸
        //   imageSize: new AMap.Size(25, 34) // 图片实际尺寸
        // });
        // var marker = new AMap.Marker({
        //   content: content,
        //   position: new AMap.LngLat(data.lng, data.lat)
        //   // 将 html 传给 content
        //   // icon: icon
        //   // content: markerContent,
        // });
        // this.map.add(marker);
      })
    },
    washCountInput(val) {
      this.washCount1 = val
    },
    beautyCountInput(val) {
      this.beautyCount1 = val
    },
    repairCountInput(val) {
      this.repairCount1 = val
    },
    copyCountInput(val) {
      this.copyCount1 = val
    },
    TabsIndex() {
      this.$emit('changeTabInfo', this.active)
      // console.log('changeTabInfo', this.active)
    },
    ShowTab() {
      if (localStorage.get('shopinfo_showtab')) {
        this.active = localStorage.get('shopinfo_showtab')
        localStorage.remove('shopinfo_showtab')
      }
    },
    upload2(val) {
      if (val && val.code === '200') {
        const { index, data } = val
        const item = this.CertificatePhotoData[index]
        item.imgUrl = data || ''
        this.startImgNum = this.CertificatePhotoData.length
        console.log(index, 'index')
        this.$set(this.CertificatePhotoData, index, item)
        if (item.name === '其他形象图' && index + 1 === this.CertificatePhotoData.length) {
          this.CertificatePhotoData.push({
            urlType: 'other',
            imgUrl: '',
            name: '其他形象图'
          })
          console.log('yesyes')
        } else {
          console.log('no')
        }
        this.endImgNum = this.CertificatePhotoData.length
        console.log(this.endImgNum, 'end')
      } else {
        tuhu.toast(val.message || '网络错误')
      }
    },
    onShopBossConfirm(value) {
      this.$set(this.shopBasicData, 'shopPrincipalType', value === '店长' ? 2 : value === '老板' ? 1 : 0)
      this.shopBossPickerFlag = false
    },
    // '加盟连锁店', '品牌自营连锁店', '私营门店'
    onShopTypeConfirm(value) {
      this.$set(this.shopMerchantData, 'shopType', value)
      this.shopTypePickerFlag = false
    },
    // 主营业务 ['洗车', '美容装潢', '维修保养', '综合服务', '轮胎']
    onShowMainConfirm(value) {
      this.$set(this.shopMerchantData, 'mainService', value)
      this.showMainPickerFlag = false
    },
    // 营业面积
    onShowAreaConfirm(value) {
      this.$set(this.shopMerchantData, 'merchantArea', value)
      this.showAreaPickerFlag = false
    },
    // 保存门店基本信息
    async saveShopBaseInfo() {
      const {
        cityId,
        cityName,
        districtId,
        districtName,
        provinceId,
        provinceName,
        shopAddress,
        shopLatitude,
        shopLongitude,
        shopName,
        shopPhone,
        shopPrincipal,
        shopPrincipalPhone,
        shopPrincipalType
      } = this.shopBasicData
      try {
        const params = {
          cityId,
          cityName,
          districtId,
          districtName,
          provinceId,
          provinceName,
          shopAddress,
          shopLatitude: 0,
          shopLongitude: 0,
          shopName,
          shopPhone,
          shopPrincipal,
          shopPrincipalPhone,
          shopPrincipalType
        }
        const data = await tuhu.fetch(`${config.apis.CHANGE_SHOP_DETAIL}`, {
          method: 'post',
          body: JSON.stringify({
            merchantShopDetailInfo: params,
            shopId: this.shopId
          })
        })
        if (data && data.code === '200') {
          tuhu.toast('保存成功')
          // location.reload()
          this.$parent.ShowTab()
          this.$parent.getShopInfo()
          this.$parent.getShopBasicInfo()
        } else {
          tuhu.toast(data.message || '网络错误')
        }
      } catch (e) {
        tuhu.toast(e.message || '网络错误')
      }
    },
    // 保存店铺信息
    async saveShopMerInfo() {
      try {
        const { businessItemsSelected } = this
        const {
          // businessItems,
          // haveRestArea,
          mainService,
          merchantArea,
          shopBank,
          shopType
          // stationCondition,
          // washCount,
          // beautyCount,
          // repairCount,
          // copyCount
        } = this.shopMerchantData
        let stationCondition = `洗车_${this.washCount1};美容_${this.beautyCount1};维护_${this.repairCount1};烤漆_${this.copyCount1}`
        // const businessItems = businessItemsSelected.join(',')
        // 所有和选择的项目
        // let businessItems = businessItemsSelected.slice(1).join(',')
        let businessItems = businessItemsSelected.join(',')
        // console.log('11qqq1', businessItemsSelected.join(',')) // 发送的数据
        // 有无休息区
        const haveRestArea = parseInt(this.restArea)
        const shopStoreInfo = {
          businessItems,
          haveRestArea,
          mainService,
          merchantArea,
          shopBank,
          shopType,
          stationCondition
        }
        const params = {
          shopId: this.shopId,
          shopStoreInfo
        }
        const data = await tuhu.fetch(`${config.apis.CHANGE_SHOP_STOREINFO}`, {
          method: 'post',
          body: JSON.stringify(params)
        })
        if (data && data.code === '200') {
          tuhu.toast('保存成功')
          // location.reload()
          this.$parent.ShowTab()
          this.$parent.getMerchantInfo()
        } else {
          tuhu.toast(data.message || '网络错误')
        }
      } catch (e) {
        tuhu.toast(e.message || '网络错误')
      }
    },
    // 保存企业信息
    async saveCompanyInfo() {
      try {
        const {
          // businessLicense,
          enterprisePrincipal,
          enterprisePrincipalPhone,
          staffNum,
          shopCreditCode,
          businessEntity
        } = this.shopCompanyData
        const { businessLicense } = this
        // const enterprisePrincipal = this.businessLicenseFlag ? this.shopCompanyData.enterprisePrincipal : ''
        // const enterprisePrincipalPhone = this.businessLicenseFlag ? this.shopCompanyData.enterprisePrincipalPhone : ''
        const params = {
          businessLicense,
          enterprisePrincipal,
          enterprisePrincipalPhone,
          staffNum,
          shopCreditCode,
          businessEntity
        }

        if (businessLicense == 1) {
          let reg = /^[A-Za-z0-9]{18,18}$/
          if (!reg.test(this.shopCompanyData.shopCreditCode)) return tuhu.toast('请输入正确的企业信用代码')
        }

        const data = await tuhu.fetch(`${config.apis.CHANGE_SHOP_COMPANYINFO}`, {
          method: 'post',
          body: JSON.stringify({
            shopCompanyInfo: params,
            shopId: this.shopId
          })
        })
        if (data && data.code === '200') {
          tuhu.toast('保存成功')
          this.$emit('hide')
          // location.reload()
          this.$parent.ShowTab()
          this.$parent.getCompanyInfo()
        } else {
          tuhu.toast(data.message || '网络错误')
        }
      } catch (e) {
        tuhu.toast(e.message || '网络错误')
      }
    },
    // 保存店照证照
    async saveShopImgs() {
      try {
        const list = this.CertificatePhotoData
        let urlInfoList = []
        list.forEach(item => {
          if (item.imgUrl) {
            urlInfoList.push({
              imgUrl: item.imgUrl,
              urlType: item.urlType
            })
          }
        })
        const data = await tuhu.fetch(`${config.apis.CHANGE_SHOP_URLINFO}`, {
          method: 'post',
          body: JSON.stringify({
            shopId: this.shopId,
            urlInfoList
          })
        })
        if (data && data.code === '200') {
          tuhu.toast('保存成功')
          // location.reload()
          this.$parent.ShowTab()
          this.$parent.getCertificatePhoto()
        } else {
          tuhu.toast(data.message || '网络错误')
        }
      } catch (e) {
        tuhu.toast(e.message || '网络错误')
      }
    },
    handleSave() {
      console.log('this.active', this.active)
      localStorage.set('shopinfo_showtab', this.active)
      switch (this.active) {
        case 0: {
          this.$emit('hide')
          this.saveShopBaseInfo()
          break
        }
        case 1: {
          this.$emit('hide')
          // console.log('ac', this.active)
          this.saveShopMerInfo()
          break
        }
        case 2: {
          this.saveCompanyInfo()
          break
        }
        case 3: {
          this.$emit('hide')
          this.saveShopImgs()
          break
        }
      }
    }
  }
}
</script>
<style lang="less">
.shop-item.cont {
  .van-cell__value {
    text-align: right;
  }
}
</style>
<style lang="less" scoped>
.shopInfoCom {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.tabs {
  width: 100%;
}
.van-tabs {
  width: 100%;
}
.shop_img {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0.2rem 0.2rem;
  .certificate_photo {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.25rem 0.5rem;
    .img-cont {
      width: 7.5rem;
      height: 4rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #fff;
      border-radius: 0.2rem;
      img {
        width: 7.5rem;
        height: 4rem;
      }
      .add-icon {
        width: 1.2rem;
        height: 1.2rem;
      }
    }
    span {
      font-size: 0.7rem;
      padding: 0.2rem;
    }
  }
}
.shop-map {
  position: relative;
  margin: 0.5rem auto;
  width: 90%;
  height: 8rem;
  .addressInfo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 290px;
    height: 3rem;
    background-color: #fff;
    /* background: url('https://res.tuhu.org/static/wx/images/shops/tabBg.png') no-repeat; */
    /* background-size: 100%; */
    padding-left: 15px;
    border-radius: 0.2rem;
  }
  .addressInfo .leftDesc {
    float: left;
    width: 94%;
    padding: 0 5px;
  }
  .addressInfo .leftDesc2 {
    width: 100%;
  }
  .addressInfo .leftDesc .title {
    color: #333;
    font-size: 15px;
    height: 1.5rem;
    line-height: 1.5rem;
    overflow: hidden;
    -ms-text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .addressInfo .leftDesc .subtitle {
    color: #999;
    font-size: 13px;
    // height: 17px;
    // line-height: 17px;
    overflow: hidden;
    -ms-text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    // margin-top: -10px;
  }
  .addressInfo::after {
    content: '';
    display: table;
    clear: both;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopInfo.vue